export default __webpack_public_path__ + "assets/xmp_bg.8e000406.svg";